import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/RoundTypeService";
const store = {};
const mutations = {

    SET_ROUND_TYPE_LIST(state, posts) {
        state.roundTypeList = posts;
        state.roundTypeListIsLoading = false;
    },
    GET_DETAIL(state, posts) {
        if (posts.success == true) {
            state.roundTypeDetail = posts.data;
            state.roundTypeDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SAVE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.roundTypeDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
};
const state = {
    roundListIsLoading: false,
    roundList: [],
    roundDetail: {},
    roundDetailChanged: false
};
const getters = {};
const actions = {

    getRoundTypeList({ commit }) {
        state.roundTypeListIsLoading = true;
        axios
            .get(baseUri + '/GetList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_ROUND_TYPE_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getRoundTypeDetail({ commit }, data) {
        state.roundTypeListIsLoading = true;
        var formData = new FormData();
        formData.append("rouId", data.rouId);
        axios
            .post(baseUri + '/GetDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveRoundTypeDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.roundTypeDetail));
        axios
            .post(baseUri + '/SaveDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
            });
    }
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}